import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table transaction report view.
 */
export default class recordTableTransReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for displaying filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails2',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Historial de Transacciones'), // Title of the window
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable', // Data table for displaying transaction details
                id: 'dtDetails2',
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'Id',
                        header: _('Ticket Det Id'), // Column header
                        minWidth: 100,
                        adjust: 'data', // Width adjusts to content
                        sort: 'int', // Sorting type
                    },
                    { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' },
                    {
                        id: 'TicketId',
                        header: _('Ticket ID'),
                        minWidth: 100,
                        adjust: 'data', // Width adjusts to content
                        sort: 'int',
                    },
                    { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' },
                    {
                        id: 'TransactionId',
                        header: _('Transacción Id'),
                        minWidth: 150,
                        adjust: 'data', // Width adjusts to content
                        sort: 'int',
                    },
                    {
                        id: 'Amount',
                        header: _('Monto'),
                        width: 100,
                        format: webix.i18n.priceFormat, // Formatting for price
                        exportType: 'number',
                        sort: 'int',
                    },
                ],
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                {
                    id: 'Id',
                    header: _('Ticket Det Id'),
                    minWidth: 100,
                    adjust: 'data', // Width adjusts to content
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' },
                {
                    id: 'TicketId',
                    header: _('Ticket ID'),
                    minWidth: 100,
                    adjust: 'data', // Width adjusts to content
                    sort: 'int',
                },
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' },
                {
                    id: 'TransactionId',
                    header: _('Transacción Id'),
                    minWidth: 150,
                    adjust: 'data', // Width adjusts to content
                    sort: 'int',
                },
                {
                    id: 'Amount',
                    header: _('Monto'),
                    width: 100,
                    format: webix.i18n.priceFormat,
                    exportType: 'number',
                    sort: 'int',
                },
            ],
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data grid instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistoryTransactions'; // API endpoint for fetching transaction history

        // Recalculate ID column width after each load
        grid.attachEvent('onAfterLoad', function () {
            this.adjustColumn('Id', 'data');
            this.adjustColumn('TicketId', 'data');
            this.adjustColumn('TransactionId', 'data');
        });
        $$('dtDetails2').attachEvent('onAfterLoad', function () {
            this.adjustColumn('Id', 'data');
            this.adjustColumn('TicketId', 'data');
            this.adjustColumn('TransactionId', 'data');
        });

        this.on(this.app, 'user:id', (idUser) => {
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?id=' + idUser); // Load data for the specific user
            $$('dtDetails2').clearAll(); // Clear details data table
            $$('dtDetails2').load(url + '?id=' + idUser); // Load details for the specific user
        });
    }
}

// FILE DOCUMENTED
